
<div class="streams-page"  *ngIf="stream" > 

    <h5>Налаштування доступу</h5> 

    <div class="row" *ngIf="!levelLoading; else loading" >


        <div style="flex-direction:row; display:flex; display: flex;  justify-content: space-between; " class="col-12">

            <div (click)="setAccessLevel(item.level)" [ngClass]='{ 
	active : (streamAccessLevel === item.level),
	disabledAccessLevel : (2 === item.level)
 }' class="accessLevelItem" *ngFor="let item of accessLevels">
                <span>
                    {{item.text}}
                </span>

               
                <span  class="lbl">
                   <div> <div *ngIf="streamAccessLevel === item.level"> </div>
                   </div>
                </span>
            </div>
            
        </div>
        
        <div class="col-12">

            <div class="row">
                <div *ngIf="streamAccessLevel === 0" class="col-12 streamAccessLevelPanel">
                  <h6 class="coverText">Відкрита трансляція</h6>  
                </div>
                <div  *ngIf="streamAccessLevel === 1"  class="col-12 streamAccessLevelPanel">
                 
                    <div class="keyGeneratePanel">



                    <div class="keyGenerateForm">
                        <h5>Генерація ключів </h5>
                        <div class="keyGenerateInputWrapper">
                                <span>Скільки ключів потрібно? </span>
                                <input type="number" nbInput (change)="keyGeneratorQuantity = $event.target.value"  [value]="keyGeneratorQuantity" placeholder="0" />
                        </div>
                        <div>
                            <button (click)="genereteKeys()" nbButton status="primary">Згенерувати</button>
                        </div>
                    </div>




                    <div class="keysWrapper">

                        <nb-card *ngIf="accessKeys?.length > 0" class="own-scroll">
                            <nb-card-header>
				<div style="display:flex">
                              <div>Ключі доступу</div>  
<div  style="display:flex; margin-left:auto; cursor:pointer;  margin-top: auto;
    margin-bottom: auto;"> <nb-icon (click)="openRemoveModal(confirmDeleteKeys,$event)" status="danger" [icon]="'trash-outline'" pack="eva"></nb-icon> </div>
				</div>
                            </nb-card-header>
                            <nb-card-body class="keysCardBody">
                                <div #keysRef >
                                <div class="keysList"  *ngFor="let group of accessKeys">
                                    <div   *ngFor="let key of group.keys">
                                        <div>{{key.password}}</div>
                                    </div>
          
                                    <hr/>
                                </div>
                
                                 </div>
                            </nb-card-body>
                            <nb-card-footer>
                                <div style="display: flex;">
                                    <div style="display: flex;">
                                        <a (click)="copyAllKeysToClipboard(keysRef)" href="javascript:;">Копіювати</a>

                                    </div>
                                    <div style="display: flex; margin-left: auto;">
                                        <a (click)="downloadAllKeysInTxt(keysRef)" href="javascript:;">Завантажити txt</a>

                                    </div>
                                </div>
                             
                                </nb-card-footer>
                            </nb-card>
                      


                    </div>
  
                
                </div> 
             </div>
             
<div  *ngIf="streamAccessLevel === 2"  class="col-12  streamAccessLevelPanel">
                <h6 class="coverText"> Доступ після оплати</h6>
            </div>
             
            </div>
  

        </div>


    </div>
 

</div> 
     


 <ng-template #confirmDeleteKeys let-data let-ref="dialogRef">
      <nb-card>
        <nb-card-header>

    <div style="display:flex; width:100%">
      <span>Підтвердіть видалення</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer; "  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon> 
	</span>  
    </div>

	</nb-card-header>

        <nb-card-body>
	<p>Ця дія безповоротно видалить усі ключі цього стріму!</p>
	</nb-card-body>
        <nb-card-footer>
	
	<div>
	
          <button style="margin-right:15px" nbButton status="danger" (click)="clearAllKeys(ref)">Видалити</button>

          <button nbButton status="basic"  (click)="ref.close()">Скасувати</button>
	</div>

        </nb-card-footer>
      </nb-card>
    </ng-template>


  
<ng-template #loading>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div>
</ng-template> 
